import { StyleSheet } from 'react-native';
import { PALETTE } from '../../../../constants';

export default StyleSheet.create({
  flag: {
    width: 115,
    top: 10,
    left: 2,
    borderWidth: 1,
    borderColor: PALETTE.primaryActive,
    backgroundColor: PALETTE.primaryBackground,
    paddingHorizontal: 10,
    paddingVertical: 2,

    flex: 1,
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  },
  flagDate: {
    color: PALETTE.secondaryText,
    textAlign: 'right',
  },
  flagPrice: {
    color: PALETTE.secondaryActive,
    textAlign: 'right',
  },
});
